// Shop tabs functionality
document.addEventListener('DOMContentLoaded', function() {
  const tabContainers = document.querySelectorAll('.w-tabs');
  
  tabContainers.forEach(function(container) {
    const tabLinks = container.querySelectorAll('.w-tab-link');
    const tabPanes = container.querySelectorAll('.w-tab-pane');
    
    tabLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetTab = link.getAttribute('data-w-tab');
        
        // Remove active classes from all tabs and panes
        tabLinks.forEach(function(l) {
          l.classList.remove('w--current');
        });
        tabPanes.forEach(function(pane) {
          pane.classList.remove('w--tab-active');
        });
        
        // Add active class to clicked tab
        link.classList.add('w--current');
        
        // Show corresponding pane
        tabPanes.forEach(function(pane) {
          if (pane.getAttribute('data-w-tab') === targetTab) {
            pane.classList.add('w--tab-active');
          }
        });
      });
    });
  });
});

